module.exports = __webpack_public_path__ + "media/images/static/benefit/h2_merit2-72cffd6922978ae935967f7041443ffe.png";